import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'features/auth';
import { ROUTES } from 'lib/constants';

/** Routes available only when signed out (e.g. login). */
export function PublicRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    // Honour the destination ProtectedRoute saved before bouncing to /login,
    // so a deep-link survives the round-trip through sign-in.
    const destination = location.state?.from?.pathname || ROUTES.DASHBOARD;
    return <Navigate to={destination} replace />;
  }
  return <Outlet />;
}

export default PublicRoute;
